import { render, staticRenderFns } from "./NextButtons.vue?vue&type=template&id=49821168"
import script from "./NextButtons.vue?vue&type=script&lang=js"
export * from "./NextButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports